import * as React from "react";

function SvgIcons8StaticViews(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M10 4v18h18V4H10zm2 2h14v2H12V6zm-8 4v18h18v-4h-2v2H6V16h2v-2H6v-2h2v-2H4zm8 0h14v10H12V10zm2 2v2h2v-2h-2zm4 0v2h6v-2h-6zm-4 4v2h2v-2h-2zm4 0v2h6v-2h-6z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8StaticViews);
